import type { CityDailyConfig } from '../config';

/**
 * Audio mapping for city-distance modes — same curves as the practice
 * mode so the audio feel is consistent across formats. Could later
 * diverge per-format if daily wants its own signature sound.
 */
function travelDurationMsForKm(km: number): number {
  const minMs = 500;
  const maxMs = 2000;
  const ref = Math.sqrt(8000);
  const t = Math.min(1, Math.sqrt(Math.max(0, km)) / ref);
  return minMs + (maxMs - minMs) * t;
}

function dingFrequenciesForKm(km: number): number | number[] {
  if (km < 80) return [523.25, 659.25, 783.99]; // C major chord
  const lo = 300;
  const hi = 880;
  const refKm = 6500;
  const t = Math.min(1, km / refKm);
  return hi * Math.pow(lo / hi, t);
}

/**
 * Daily Cities — five tier-2 cities chosen deterministically from the
 * user's local date. Same five for every player on the same wall-clock
 * day (per-timezone), so a share grid is meaningful.
 *
 * `seedSource: 'utc-date'` is the schema slot for "deterministic per
 * date"; the runtime currently uses local date (see dailyDate.ts).
 * Rename when we settle the field name; behavior is what matters.
 */
export const citiesWorldDaily: CityDailyConfig = {
  id: 'cities-world-daily',
  scope: { entity: 'cities', region: 'world' },
  format: 'daily',
  interaction: 'click-distance',

  displayName: 'Daily Cities',
  shortName: 'Daily',

  layers: {
    texture: { visible: true, opacity: 1.0 },
    borders: { visible: true, opacity: 0 },
    fills: { visible: false, opacity: 0.55 },
    hover: false,
  },
  // Daily is a fixed test — no in-game layer toggling that could be
  // construed as cheating. Practice mode is the place to experiment.
  userMayToggle: {
    texture: false,
    borders: false,
    fills: false,
    hover: false,
  },

  unitSystem: 'miles',
  tierMax: 2,
  cityFilter: {},
  rounds: 5,
  seedSource: 'utc-date',
  promptFormat: 'city-country',
  audio: { travelDurationMsForKm, dingFrequenciesForKm },
};
